/* eslint-disable react/destructuring-assignment */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';

// custom function import
import { validDate } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchCoverageTable,
  handleErrorMessages,
  maintainContractActions,
  dispatchDeleteCoverageGap,
  addCoverageDate,
} from '../../store/actions';
import {
  MinDate,
  MaxDate,
  dateFormatForDatePicker,
  dateFormatDatePicker,
} from '../../../../../SharedModules/CommonConstants/commonConstants';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../../SharedModules/DateUtilities/DateUtilities';

export default (props) => {
  const dispatch = useDispatch();
  const { colId } = props.column;
  const { rowIndex } = props;
  const { isEnablebyRole = true } = props;
  const getCoverageTable = useSelector((state) => {
    return state.sharedState.ContractReducer?.getCoverageTable;
  });
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.ContractReducer?.errorMessagesInRedux;
  });
  const maintainContractState = useSelector(
    (state) => state.sharedState.ContractReducer.maintainContractState
  );
  const deleteCoverageGap = useSelector(
    (state) => state.sharedState.ContractReducer.deleteCoverageGap
  );
  const getOnLoadCoverageData = useSelector(
    (state) => state.sharedState.ContractReducer.getOnLoadCoverageData
  );
  // handing on change date event
  const handleOnChangeDateFields = (d, name) => {
    let localErr = errorMessagesFromRedux || [];
    const newObj = [...getCoverageTable];
    if (d !== 'Invalid Date') {
      newObj[rowIndex][name] = d;
      props.node.setDataValue(colId, d);
      dispatch(dispatchCoverageTable(newObj[rowIndex], rowIndex, name, 'Add'));
      if (newObj[rowIndex].alreadyAdded == true) {
        const getLoadCoverage = getOnLoadCoverageData || [];
        const deletedValue = {};
        if (getLoadCoverage.length > 0) {
          getLoadCoverage &&
            getLoadCoverage.map((item) => {
              if (
                newObj[rowIndex].indexKey === item.indexKey &&
                newObj[rowIndex].indexKey !== ''
              ) {
                dispatch(dispatchDeleteCoverageGap(item));
              }
            });
        }
      }

      localErr = localErr?.filter(
        (item) =>
          item.fieldName !== `${colId}${rowIndex}` &&
          item.errorType !== ('InvalidDate' || 'compareDateGreater')
      );
      dispatch(handleErrorMessages([...new Set(localErr)]));
      dispatch(
        maintainContractActions({
          ...maintainContractState,
          showSaveButton: 'Yes',
        })
      );
    }
  };

  const doQuartersOverlap = (dates) => {
    let myArr = [...dates];
    myArr = myArr.map((el) => {
      if (el.endDate === 'Invalid date') {
        return {
          ...el,
          startDate: new Date(el.startDate),
          endDate: new Date('12/31/9999'),
        };
      }
      return {
        ...el,
        startDate: new Date(el.startDate),
        endDate: new Date(el.endDate),
      };
    });
    let overlap = [];

    for (let i = 0; i < myArr.length; i++) {
      for (let j = i + 1; j < myArr.length; j++) {
        // Check if the date ranges overlap
        if (
          myArr[i].startDate <= myArr[j].endDate &&
          myArr[j].startDate <= myArr[i].endDate
        ) {
          // Add the indexes of the overlapping objects to the array
          overlap.push(i, j);
        }
      }
    }
    return (overlap = [...new Set(overlap)]);
  };

  // call on Blur event filed level
  const handleOnBlurDate = (d) => {
    const newObj = [...getCoverageTable];

    // overlap validation
    let tempArr = [...newObj];
    tempArr = tempArr.map((el) => {
      return {
        ...el,
        startDate: moment(el.startDate).format('MM/DD/YYYY'),
        endDate: moment(el.endDate).format('MM/DD/YYYY'),
      };
    });
    const quarterOverlap = doQuartersOverlap(tempArr);
    let localErr = errorMessagesFromRedux || [];
    let { value } = d.target;
    if (d.target.value && d.target.value.length > 5) {
      const data = d.target.value.split('/');
      if (data[2].split('_').length === 3) {
        value = moment(d.target.value, 'MM/DD/YY').format('MM/DD/YYYY');
      }
    }
    if (value && validDate(new Date(value)) === false) {
      props.node.setDataValue(colId, value);
      newObj[rowIndex][colId] = value;
      if (colId === 'startDate') {
        newObj[rowIndex].startDateErr = true;
      }
      if (colId === 'endDate') {
        newObj[rowIndex].endDateErr = true;
      }
      dispatch(dispatchCoverageTable(newObj[rowIndex], rowIndex, colId, 'Add'));
      localErr.push({
        fieldName: `${colId}${rowIndex}`,
        errorType: 'InvalidDate',
        tabName: 'CoverageGap',
        message: `${
          constantMessageData.DATE_INVALID_FORMAT_ERROR_DRUG_FAMILY
        } ${rowIndex + 1}.`,
      });
    } else if (colId === 'startDate') {
      if (value && compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))) {
        localErr = localErr?.filter(
          (item) =>
            item.fieldName !== `${colId}${rowIndex}` &&
            item.errorType !== ('InvalidDate' || 'compareDateGreater')
        );
        localErr.push({
          fieldName: `${colId}${rowIndex}`,
          errorType: 'compareDateGreater',
          tabName: 'CoverageGap',
          message: `${constantMessageData.MINIMUM_START_ERROR_DRUG_FAMILY} ${
            rowIndex + 1
          }.`,
        });
        props.node.setDataValue(colId, value);
        newObj[rowIndex][colId] = value;
        newObj[rowIndex].startDateErr = true;
        dispatch(
          dispatchCoverageTable(newObj[rowIndex], rowIndex, colId, 'Add')
        );
      } else {
        localErr = localErr?.filter(
          (item) =>
            item.fieldName !== `${colId}${rowIndex}` &&
            item.errorType !== ('InvalidDate' || 'compareDateGreater')
        );
        newObj[rowIndex].startDateErr = false;
        dispatch(
          dispatchCoverageTable(newObj[rowIndex], rowIndex, colId, 'Add')
        );
      }
      if (
        props?.data?.endDate &&
        compareTwoDatesGreaterThanOrEqual(props?.data?.endDate, moment(value))
      ) {
        localErr = localErr?.filter(
          (item) =>
            item.fieldName !== `endDate${rowIndex}` &&
            item.errorType !== ('InvalidDate' || 'compareDateGreater')
        );
        localErr.push({
          fieldName: `endDate${rowIndex}`,
          errorType: 'compareDateGreater',
          tabName: 'CoverageGap',
          message: `${
            constantMessageData.END_DATE_GREATER_THAN_START_DATE_DRUG_FAMILY
          } ${rowIndex + 1}.`,
        });
        props.node.setDataValue(colId, value);
        newObj[rowIndex][colId] = value;
        newObj[rowIndex].endDateErr = true;
        dispatch(
          dispatchCoverageTable(newObj[rowIndex], rowIndex, colId, 'Add')
        );
      } else {
        localErr = localErr?.filter(
          (item) =>
            item.fieldName !== `endDate${rowIndex}` &&
            item.errorType !== ('InvalidDate' || 'compareDateGreater')
        );
        newObj[rowIndex].endDateErr = false;
        dispatch(
          dispatchCoverageTable(newObj[rowIndex], rowIndex, colId, 'Add')
        );
      }
    } else if (colId === 'endDate') {
      if (
        value &&
        compareTwoDatesGreaterThanOrEqual(
          value,
          moment(props?.data?.startDate || MinDate)
        )
      ) {
        localErr = localErr?.filter(
          (item) =>
            item.fieldName !== `${colId}${rowIndex}` &&
            item.errorType !== ('InvalidDate' || 'compareDateGreater')
        );
        localErr.push({
          fieldName: `${colId}${rowIndex}`,
          errorType: 'compareDateGreater',
          tabName: 'CoverageGap',
          message: `${
            constantMessageData.END_DATE_GREATER_THAN_START_DATE_DRUG_FAMILY
          } ${rowIndex + 1}.`,
        });
        newObj[rowIndex].endDateErr = true;
      } else {
        localErr = localErr?.filter(
          (item) =>
            item.fieldName !== `${colId}${rowIndex}` &&
            item.errorType !== ('InvalidDate' || 'compareDateGreater')
        );
        newObj[rowIndex].endDateErr = false;
        dispatch(
          dispatchCoverageTable(newObj[rowIndex], rowIndex, colId, 'Add')
        );
      }
    }
    dispatch(handleErrorMessages([...new Set(localErr)]));
    dispatch(
      maintainContractActions({
        ...maintainContractState,
        showSaveButton: 'Yes',
      })
    );
    if (newObj[rowIndex].alreadyAdded == true) {
      const getLoadCoverage = getOnLoadCoverageData || [];
      const deletedValue = {};
      if (getLoadCoverage.length > 0) {
        getLoadCoverage &&
          getLoadCoverage.map((item) => {
            if (
              newObj[rowIndex].indexKey === item.indexKey &&
              newObj[rowIndex].indexKey !== ''
            ) {
              dispatch(dispatchDeleteCoverageGap(item));
            }
          });
      }
    }
    if (quarterOverlap.length > 0) {
      const array = [];
      let msg = '';
      const errList = [];

      quarterOverlap.forEach((li, index) => {
        msg += `Row ${li + 1} ${
          quarterOverlap.length !== index + 1 ? ' and ' : ''
        }`;
      });
      newObj.filter((data, index) => {
        if (quarterOverlap.includes(index)) {
          errList.push({
            colId: colId,
            rowId: index,
          });
        }
      });
      array.push({
        fieldName: `${colId}`,
        errorType: 'quarterOverlap',
        tabName: 'CoverageGap',
        message: `${'Start and End Date Overlap on'} ${msg}.`,
        errList: errList,
      });
      const temArr = localErr.filter((data) => {
        if (data.errorType !== 'quarterOverlap') return data;
      });
      localErr = [...temArr, ...array];
    } else {
      localErr = localErr.filter((data) => {
        if (data.errorType !== 'quarterOverlap') return data;
      });
    }
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };

  const checkoverlap = (key, id) => {
    let obj = {};
    if (errorMessagesFromRedux?.length > 0) {
      errorMessagesFromRedux.find((data) => {
        if (data.errorType === 'quarterOverlap') {
          data.errList.find((li) => {
            if (li.colId === key && li.rowId === id) {
              obj = data;
            }
          });
        }
      });
      if (Object.keys(obj)?.length > 0) {
        return true;
      } else return false;
    }
  };

  return (
    <div data-testid="log-check-date-picker">
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          required
          id="begin_date_net_association_bp_tab"
          format={dateFormatForDatePicker}
          inputFormat={dateFormatForDatePicker}
          mask="__/__/____"
          minDate={
            colId === 'startDate' ? MinDate : new Date(props.data.startDate)
          }
          maxDate={MaxDate}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={isEnablebyRole === false}
          className={
            colId === 'startDate'
              ? getCoverageTable[rowIndex]?.startDateErr ||
                checkoverlap('startDate', rowIndex)
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
              : // eslint-disable-next-line no-nested-ternary
              colId === 'endDate'
              ? getCoverageTable[rowIndex]?.endDateErr ||
                checkoverlap('endDate', rowIndex)
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
              : 'frr-display-hidden-label'
          }
          InputProps={{
            readOnly: isEnablebyRole === false,
            autoFill: false,
          }}
          placeholder={dateFormatDatePicker}
          value={props.value}
          onKeyDown={async (e) => {
            if (e.keyCode == 67) {
              // copy date
              await window.navigator?.clipboard.writeText(e?.target?.value);
            }
          }}
          onChange={(d) => {
            handleOnChangeDateFields(d, colId);
          }}
          onBlur={(e) => {
            handleOnBlurDate(e);
          }}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          helperText={null}
          error={null}
        />
      </MuiPickersUtilsProvider>
    </div>
  );
};
